import React, { useEffect, useState } from "react";
import "../styles/EmiOptions.css";

function EmiOptions() {
  const [form, setForm] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem("emi_form");
    if (stored) setForm(JSON.parse(stored));
  }, []);

  const handleEmiClick = async () => {
    const stored = localStorage.getItem("emi_form");
    if (!stored) return alert("Missing form data.");

    try {
      const res = await fetch("/backend/initiate-mandate.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: stored
      });

      let result;
      try {
        result = await res.json();
      } catch (err) {
        const text = await res.text();
        console.error("Invalid JSON from backend:", text);
        alert("Mandate failed: Invalid response from server.");
        return;
      }

      console.log("Mandate Result:", result);

      if (result.success && result.redirect) {
        window.location.href = result.redirect;
      } else {
        const reason =
          result.reason ||
          result.message ||
          result.debug?.StatusDesc ||
          "Unknown error";
        alert("Mandate failed: " + reason);
      }
    } catch (error) {
      console.error("Network error:", error);
      alert("Network error during mandate.");
    }
  };

  if (!form) return <p>Loading EMI details...</p>;

  return (
    <div className="emi-options-page">
      <h1>EMI Payment Options</h1>
      <p>Please choose a method to continue:</p>

      <div className="emi-boxes">
        <div className="emi-box" onClick={handleEmiClick}>
          <h2>Online E-Nach (E-Mandate)</h2>
          <p>Authorize recurring payments securely via NetBanking or Aadhaar.</p>
          <button>Continue with E-Mandate</button>
        </div>

        <div className="emi-box disabled">
          <h2>UPI Autopay</h2>
          <p>Coming soon. Autopay via UPI mandate handle.</p>
        </div>
      </div>
    </div>
  );
}

export default EmiOptions;
